var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 32,
    viewBox: "0 0 42 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.4899,
    y: 7.2002,
    width: 7.92781,
    height: 20.9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58804 26.511L17.4181 2.28482C18.3349 0.882157 19.5711 0.111328 20.9036 0.111328C22.2372 0.111328 23.474 0.882778 24.3905 2.28607L40.1829 26.4743C41.0993 27.8767 41.2709 29.2159 40.6682 30.2495C40.0609 31.2896 38.7594 31.8608 37.0023 31.8627L4.75791 31.886H4.78536V31.8891C3.2106 31.8891 1.71625 31.3204 1.10962 30.2837C0.506821 29.2532 0.671555 27.9143 1.58804 26.511ZM20.025 27.0533C20.2593 27.2756 20.5754 27.4019 20.9068 27.4019C21.2376 27.4019 21.5595 27.2744 21.7949 27.0521C22.0282 26.8297 22.1606 26.5194 22.1603 26.2023C22.1596 25.887 22.0822 25.5785 21.8481 25.3581C21.6092 25.1336 21.4066 25.0051 21.0915 25.0051L21.0326 25.0045C20.7025 25.0045 20.3103 25.1336 20.073 25.3593C19.8383 25.5813 19.67 25.8888 19.6707 26.2048C19.671 26.5225 19.7887 26.8319 20.025 27.0533ZM20.9029 22.6074C21.2395 22.6074 21.5517 22.4831 21.7896 22.2567C22.0276 22.03 22.1564 21.7287 22.156 21.4078L22.2881 10.5973C22.2868 9.93558 21.8001 9.39889 21.1699 9.39889H21.0251C20.6882 9.39889 20.2995 9.52358 20.0619 9.75026C19.8236 9.97725 19.6589 10.2779 19.6592 10.5988L19.6511 21.4094C19.6517 22.0698 20.2077 22.6074 20.9029 22.6074Z",
    fill: "#FAD348"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationTriangle);
export default __webpack_public_path__ + "static/media/exclamation-triangle.4700b6ecb1a59017303077fc0a0c5d39.svg";
export { ForwardRef as ReactComponent };